import { MobileShell } from '@/components/dashboard/DashboardShell';
import { FeedbackForm } from '@/components/dashboard/FeedbackForm';

export default function FeedbackMobile() {
  return (
    <MobileShell title="Feedback" subtitle="Report issues or share suggestions">
      <FeedbackForm />
    </MobileShell>
  );
}
